export const ERC20_DECIMALS = 9;
